import * as Sentry from '@sentry/react'

export function reportError(error, context = {}) {
  // Only report in prod to keep noise out during dev
  if (import.meta.env.VITE_ENVIRONMENT !== 'prod') return

  Sentry.captureException(error, {
    extra: context,
  })
}
